import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GroupsCountUseCaseInterface } from 'domain/usecases';

export class RemoteGroupsCount implements GroupsCountUseCaseInterface {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GroupsCountUseCaseInterface.Result>,
  ) {}

  async execute(
    params: GroupsCountUseCaseInterface.Params,
  ): Promise<GroupsCountUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: this.url + params.id + '/overview/groups-count',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
